/**
 * Mobile Layout with Bottom Navigation
 * Provides app shell with 4 tabs per FM3.yaml spec
 */

import React from 'react';
import { Gauge, CheckSquare, Bell, User } from 'lucide-react';

const TABS = [
  { id: 'vehicles', label: 'Vehicules', icon: Gauge, path: '/vehicles' },
  { id: 'todos', label: 'Taches', icon: CheckSquare, path: '/todos' },
  { id: 'alerts', label: 'Alertes', icon: Bell, path: '/alerts' },
  { id: 'profile', label: 'Profil', icon: User, path: '/profile' },
];

export default function MobileLayout({ children, currentTab, onTabChange, alertCount = 0 }) {
  return (
    <div className="min-h-screen bg-slate-900 flex flex-col">
      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto pb-20">
        {children}
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-slate-800 border-t border-slate-700 safe-area-bottom">
        <div className="flex justify-around items-center h-16">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = currentTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.path)}
                className={`flex flex-col items-center justify-center flex-1 h-full relative transition-colors ${
                  isActive
                    ? 'text-blue-400'
                    : 'text-slate-400 active:text-slate-200'
                }`}
              >
                <div className="relative">
                  <Icon className="w-6 h-6" />
                  {/* Alert badge */}
                  {tab.id === 'alerts' && alertCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                      {alertCount > 99 ? '99+' : alertCount}
                    </span>
                  )}
                </div>
                <span className={`text-xs mt-1 ${isActive ? 'font-medium' : ''}`}>
                  {tab.label}
                </span>
                {/* Active indicator */}
                {isActive && (
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-blue-400 rounded-b-full" />
                )}
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
